module.exports = __webpack_public_path__ + "img/noMessage.b964b8de.png";